import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import { routerMiddleware } from 'react-router-redux';
import thunk from 'redux-thunk';
import createMiddleware from './middleware/clientMiddleware';
import clientResponseMiddleware from './middleware/clientResponseMiddleware';
import reducers from './modules/reducer';
import ApiClient from '../helpers/ApiClient';

const combinedReducers = combineReducers(reducers);
const api = new ApiClient();

export default function createCombinedStore(client, data, browserHistory) {
  const middleware = [
    thunk.withExtraArgument(api),
    createMiddleware(client),
    clientResponseMiddleware(),
    routerMiddleware(browserHistory),
  ];

  let finalCreateStore;
  if ((__DEVELOPMENT__ || __STAGING__) && __CLIENT__ && __DEVTOOLS__) {
    finalCreateStore = compose(
      applyMiddleware(...middleware),
      typeof window === 'object' && typeof window.devToolsExtension !== 'undefined' ? window.devToolsExtension() : f => f,
    )(createStore);
  } else {
    finalCreateStore = applyMiddleware(...middleware)(createStore);
  }

  const store = finalCreateStore(combinedReducers, data);

  if (__DEVELOPMENT__ && module.hot) {
    module.hot.accept('./modules/reducer', () => {
      store.replaceReducer(require('./modules/reducer'));
    });
  }

  return store;
}



// WEBPACK FOOTER //
// ./src/redux/create.js